export const appRoutes = {
  home: '/',
  flowModules: '/flow-modules',
  flows: '/flows',
  users: '/users',
  userDetails: '/users/:userId',
  accessList: '/access-list',
  aiUsagePricing: '/ai-usage-pricing',
  settings: '/settings',
  legacyTokenUsage: '/token-usage',
  login: '/login',
  logout: '/logout',
  accessDenied: '/access-denied',
  emailVerification: '/verify-email',
};

export const apiRoutes = {
  firebaseAuth: `/auth`,
  accessCheck: `/auth/access`,
};
